module.exports = __webpack_public_path__ + "img/img8.c38a61e1.svg";